
import Injection = EECore.Injection;
import AdsSlideshow from "../entities/ads/adsSlideshow";
import Ads from "../entities/ads/ads";

export const DEFAULT_CONTENT_PATH = "/dashboard";
export const DEFAULT_ADSLIST_COMPONENT_NAME = "Ads List";
export const DEFAULT_SLIDESHOW_COMPONENT_NAME = "Ads Slideshow";

@Injection.injectableClass("AdsService")
export default class AdsService {

  @Injection.injectableProperty("AdsService", EECore.Registrations.CONTENT_SERVICE)
  private contentService: EECore.Services.ContentService;

  constructor(contentService: EECore.Services.ContentService) {
    this.contentService = contentService;
  }

  getList(contentPath: string = DEFAULT_CONTENT_PATH) {
    if (!contentPath) contentPath = DEFAULT_CONTENT_PATH;

    return new EECore.Promise<Ads[], string>((resolve, reject) => {
      const contentRequest = this.contentService.getContent(contentPath, "ads");
      contentRequest.then((content) => {
        resolve(content[0].fields.ads);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getTypeAds(contentPath: string = DEFAULT_CONTENT_PATH) {
    if (!contentPath) contentPath = DEFAULT_CONTENT_PATH;

    return new EECore.Promise<string, string>((resolve, reject) => {
      const contentRequest = this.contentService.getContent(contentPath, "ads");
      contentRequest.then((content) => {
        if (content.length === 0)
          resolve(null);
        else
          resolve(content[0].componentName);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getSlideshow(contentPath: string = DEFAULT_CONTENT_PATH) {
    if (!contentPath) contentPath = DEFAULT_CONTENT_PATH;

    return new EECore.Promise<AdsSlideshow, string>((resolve, reject) => {
      const contentRequest = this.contentService.getContent(contentPath, "ads");
      contentRequest.then((content) => {
        const slideshow = content[0].fields;

        for (let i = 1; i < content.length; i++) {
          const adsToAdd = content[i].fields.ads;
          slideshow.ads.push(...adsToAdd);
        }

        this.validateSlideshowParameters(slideshow);
        resolve(slideshow);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  trackAllLinks(element: Element): Element {
    if (!element) {
      return element;
    }

    const name = "data-tealium";
    if (((element.tagName || "").toUpperCase() === "A") && (!element.getAttribute(name))) {
      const href = element.getAttribute("href");
      const value = `{"event_category":"General Link", "event_action":"Carousel","event_label":"${href}"}`;
      element.setAttribute("data-tealium", value);
    }

    if (element.children) {
      for (let i=0; i<element.children.length; i++) {
        const e = element.children[i];
        this.trackAllLinks(e);
      }
    }

    return element;
  }

  private validateSlideshowParameters(slideshow: AdsSlideshow) {
    if (slideshow.ads.length <= 1) {
      slideshow.showNavigation = false;
      slideshow.showPagination = false;
      slideshow.showPlayPause = false;
      slideshow.autoPlay = false;
    }
  }
}